import { Routes, RouterModule }  from '@angular/router';
import { Pages } from './pages.component';
import { ModuleWithProviders } from '@angular/core';
// noinspection TypeScriptValidateTypes

// export function loadChildren(path) { return System.import(path); };

export const routes: Routes = [
    {
        path: 'login',
        loadChildren: 'app/pages/login/login.module#LoginModule',
    },
    {
        path: 'dashboard-message',
        loadChildren: 'app/pages/register-confirm/dashboard-msg/dashboard-msg.module#DashboardMsgModule',
    },
    {
        path: 'forgot-password',
        loadChildren: 'app/pages/passwords/forgot-password/forgot-password.module#ForgotPasswordModule',
    },
    {
        path: 'users/:id/password/reset/:reg_token',
        loadChildren: 'app/pages/passwords/set-password/set-password.module#SetPasswordModule',
    },
    {
        path: 'register',
        loadChildren: 'app/pages/register/register.module#RegisterModule',
    },
    {
        path: 'sympathizer/registration_confirm/:id/:reg_token',
        loadChildren: 'app/pages/register-confirm/sympathizer/sympathizer.module#SympathizerRegistrationConfirmModule',
    },
    {
        path: 'member/registration_confirm/:id/:reg_token',
        loadChildren: 'app/pages/register-confirm/member/member.module#MemberRegistrationConfirmModule',
    },
    {
        path: 'privacy',
        loadChildren: 'app/pages/static/privacy/privacy.module#PrivacyModule',
    },
    {
        path: 'terms',
        loadChildren: 'app/pages/static/terms/terms.module#TermsModule',
    },
    {
        path: 'pages',
        component: Pages,
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            { path: 'dashboard', loadChildren: './dashboard/dashboard.module#DashboardModule' },
            { path: 'change-password', loadChildren: './passwords/change-password/change-password.module#ChangePasswordModule' },
            { path: 'profile', loadChildren: './edit-profile/edit-profile.module#EditProfileModule' },
            { path: 'users', loadChildren: './users/users.module#UsersModule' },
            { path: 'groups_committees', loadChildren: './groups-committees/groups-committees.module#GroupsCommitteesModule' },
            { path: 'campaigns', loadChildren: './campaigns/campaigns.module#CampaignsModule' },
            { path: 'meetings', loadChildren: './meetings/meetings.module#MeetingsModule' },
            { path: 'tasks', loadChildren: './tasks/tasks.module#TasksModule' },
            { path: 'surveys', loadChildren: './surveys/surveys.module#SurveysModule' },
            { path: 'notifications', loadChildren: './notifications/notifications.module#NotificationsModule' }
        ]
    }
];

export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/pages/pages.routing.ts